/** Max time before releasing the auth loading gate (slow network / OAuth). */
export const AUTH_BOOTSTRAP_LOADING_MS = 8000;

/** Max time to wait for INITIAL_SESSION before retrying getSession. */
export const AUTH_SESSION_RESTORE_MS = 15000;

/**
 * Only clear local session on getSession errors that indicate an invalid session —
 * not on transient network failures (prevents silent logout on /auth during slow loads).
 */
export function shouldLocalSignOutOnSessionError(error: unknown): boolean {
  if (!error || typeof error !== "object") {
    return false;
  }

  const status = "status" in error ? (error as { status?: number }).status : undefined;
  if (status === 401 || status === 403) {
    return true;
  }

  const message =
    "message" in error && typeof (error as Error).message === "string"
      ? (error as Error).message.toLowerCase()
      : "";

  return (
    message.includes("invalid refresh token") ||
    message.includes("refresh token not found") ||
    message.includes("session not found")
  );
}
